import React from 'react';

export const ScaleIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        fill="none" 
        viewBox="0 0 24 24" 
        strokeWidth={1.5} 
        stroke="currentColor" 
        {...props}
    >
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 3l-6.75 6.75M12 3l6.75 6.75M2 9.75h20M12 21V6M4.5 9.75v7.5a2.25 2.25 0 002.25 2.25h1.5a2.25 2.25 0 002.25-2.25v-7.5M13.5 9.75v7.5a2.25 2.25 0 002.25 2.25h1.5a2.25 2.25 0 002.25-2.25v-7.5" />
    </svg>
);